export default __webpack_public_path__ + "static/media/phones.adfde676.png";